<div class="video-player">
  <cloudflare-stream
    [id]="video().id"
    [controls]="true"
    [src]="video().url"
    (timeupdate)="videoTimeUpdate($event)"
    (play)="play()"
  />
</div>
<lyceo-checkbox
  [checked]="watched()"
  [disabled]="watched()"
  (checkedChange)="setHasWatched()"
>
  Ik heb de video bekeken en begrijp wat er wordt uitgelegd.
</lyceo-checkbox>
